var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotLoggedInBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 803,
    height: 900,
    viewBox: "0 0 803 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 535.21,
    y: 111.948,
    width: 146.763,
    height: 146.763,
    rx: 73.3814,
    transform: "rotate(14.5 535.21 111.948)",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.21,
    y: 111.948,
    width: 146.763,
    height: 146.763,
    rx: 73.3814,
    transform: "rotate(14.5 535.21 111.948)",
    fill: "url(#paint3_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.392,
    width: 232.751,
    height: 232.751,
    rx: 116.376,
    transform: "rotate(12 131.392 0)",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.392,
    width: 232.751,
    height: 232.751,
    rx: 116.376,
    transform: "rotate(12 131.392 0)",
    fill: "url(#paint5_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304.172,
    y: 297,
    width: 102.65,
    height: 102.65,
    rx: 51.3251,
    transform: "rotate(21 304.172 297)",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.172,
    y: 297,
    width: 102.65,
    height: 102.65,
    rx: 51.3251,
    transform: "rotate(21 304.172 297)",
    fill: "url(#paint7_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.301,
    y: 633,
    width: 140,
    height: 140,
    rx: 70,
    transform: "rotate(35 299.301 633)",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.301,
    y: 633,
    width: 140,
    height: 140,
    rx: 70,
    transform: "rotate(35 299.301 633)",
    fill: "url(#paint9_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.76,
    y: 390.816,
    width: 386.511,
    height: 386.511,
    rx: 193.255,
    transform: "rotate(28.5 600.76 390.816)",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.76,
    y: 390.816,
    width: 386.511,
    height: 386.511,
    rx: 193.255,
    transform: "rotate(28.5 600.76 390.816)",
    fill: "url(#paint11_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.692,
    y: 498,
    width: 204.736,
    height: 204.736,
    rx: 102.368,
    transform: "rotate(28.5 201.692 498)",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.692,
    y: 498,
    width: 204.736,
    height: 204.736,
    rx: 102.368,
    transform: "rotate(28.5 201.692 498)",
    fill: "url(#paint13_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.692,
    y: 220,
    width: 204.736,
    height: 204.736,
    rx: 102.368,
    transform: "rotate(28.5 456.692 220)",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.692,
    y: 220,
    width: 204.736,
    height: 204.736,
    rx: 102.368,
    transform: "rotate(28.5 456.692 220)",
    fill: "url(#paint15_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.6916,
    y: 235,
    width: 204.736,
    height: 204.736,
    rx: 102.368,
    transform: "rotate(28.5 69.6916 235)",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.6916,
    y: 235,
    width: 204.736,
    height: 204.736,
    rx: 102.368,
    transform: "rotate(28.5 69.6916 235)",
    fill: "url(#paint17_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("rect", {
    x: 575.291,
    y: -157.943,
    width: 330.361,
    height: 330.361,
    rx: 160,
    transform: "rotate(28.5 575.291 -157.943)",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.291,
    y: -157.943,
    width: 330.361,
    height: 330.361,
    rx: 160,
    transform: "rotate(28.5 575.291 -157.943)",
    fill: "url(#paint19_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.289,
    y: 467.767,
    width: 146.763,
    height: 146.763,
    rx: 73.3814,
    transform: "rotate(23.5 470.289 467.767)",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.289,
    y: 467.767,
    width: 146.763,
    height: 146.763,
    rx: 73.3814,
    transform: "rotate(23.5 470.289 467.767)",
    fill: "url(#paint21_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.00000294171,
    y1: 413,
    x2: 803,
    y2: 559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CE5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#00B1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#007E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#004E69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f2022"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 535.21,
    y1: 179.296,
    x2: 680.78,
    y2: 208.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CE5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#00B1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#007E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 655.312,
    y1: 4.23462,
    x2: 498.624,
    y2: 63.3305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CE5BE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 131.392,
    y1: 106.807,
    x2: 362.251,
    y2: 153.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CE5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1B2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 291.88,
    y1: -286.699,
    x2: -2.70373,
    y2: -104.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CE5BE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 304.172,
    y1: 344.105,
    x2: 405.987,
    y2: 364.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CE5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 374.952,
    y1: 170.557,
    x2: 245.031,
    y2: 251.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CE5BE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 299.301,
    y1: 697.245,
    x2: 438.162,
    y2: 725.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CE5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#00B1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947917,
    stopColor: "#007E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 391.08,
    y1: 471.063,
    x2: 209.14,
    y2: 555.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CE5BE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 600.76,
    y1: 568.182,
    x2: 984.128,
    y2: 646.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CE5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#007E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 854.142,
    y1: -56.2568,
    x2: 351.845,
    y2: 176.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CE5BE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 201.692,
    y1: 591.951,
    x2: 404.763,
    y2: 633.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CE5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#007E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 335.909,
    y1: 261.184,
    x2: 69.8406,
    y2: 384.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CE5BE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 456.692,
    y1: 313.951,
    x2: 659.763,
    y2: 355.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CE5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#007E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 590.909,
    y1: -16.8161,
    x2: 324.841,
    y2: 106.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CE5BE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 69.6916,
    y1: 328.951,
    x2: 272.763,
    y2: 370.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CE5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#007E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 203.909,
    y1: -1.81608,
    x2: -62.1595,
    y2: 121.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CE5BE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 575.291,
    y1: -6.34413,
    x2: 902.965,
    y2: 60.4298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CE5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#007E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 791.863,
    y1: -540.068,
    x2: 362.537,
    y2: -341.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CE5BE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 470.289,
    y1: 535.115,
    x2: 615.858,
    y2: 564.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CE5BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#00B1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#007E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 590.39,
    y1: 360.054,
    x2: 433.703,
    y2: 419.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CE5BE",
    stopOpacity: 0.1
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotLoggedInBackground);
export default __webpack_public_path__ + "static/media/NotLoggedInBackground.b60db7d5bb6eb356e215b8b6b8928cc2.svg";
export { ForwardRef as ReactComponent };